// /api/bugs* answers are per-user authorization decisions over per-project data, but the serving
// cache keys function responses by URL + query with no auth dimension (`netlify-vary: query`): a
// 403 {"error":"Access denied"} computed for one request was replayed byte-identical — same date
// and x-nf-request-id — to the same session for minutes (bug-muetzmgg-4470), leaving the Bugs
// tab's Retry button refetching the identical URL into the same cached 403. The standard
// Cache-Control opt-outs were already demonstrably ignored by that cache (bug-muenvnj8-70z5), so
// every bugs API request carries a fresh cachebust value and a stored entry can never match.
// RTK Query keys its cache on the endpoint arguments, not the built URL, so a per-fetch buster
// busts only the serving cache, not the app's own dedup.
let sequence = 0

export function apiCacheBust(): string {
  return `${Date.now()}-${++sequence}`
}
